import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { advanceInstruction } from '../../redux/actions/action-engine';
import { Button } from '../domain';
import RenderHtmlWithBlob from './RenderHtmlWithBlob';
import BgAudioPlayer from './BgAudioPlayer';

const InstructionScreen = ({
  activeInstruction,
  studentId,
  onNext,
}) => {
  const bgAudioRef = useRef(null);

  useEffect(() => {
    const bgAudio = bgAudioRef.current;
    if (!bgAudio || !activeInstruction?.bgAudioUrl) return undefined;

    bgAudio.volume = 0.5;
    bgAudio.play().catch(() => {});

    return () => {
      bgAudio.pause();
      bgAudio.currentTime = 0;
    };
  }, [activeInstruction?.bgAudioUrl, activeInstruction?.id]);

  if (!activeInstruction) {
    return null;
  }

  return (
    <div className="page-instruction">
      <div className="instruction-content">
      
        <RenderHtmlWithBlob
          htmlString={activeInstruction.content}
          className="instruction-html"
        />
        {activeInstruction.audioUrl && (
          <div className="instruction-audio">
            <BgAudioPlayer
              src={activeInstruction.audioUrl}
              studentId={studentId}
              questionId={`instruction_${activeInstruction.id}`}
              audioPlayCount={1}
            />
          </div>
        )}
        <div>
        <Button className="btn btn-next btn-primary" role="presentation" onClick={onNext}>
          Continue
        </Button>
        </div>
      </div>
      {activeInstruction.bgAudioUrl && (
        <audio ref={bgAudioRef} src={activeInstruction.bgAudioUrl} loop />
      )}
      {/* <div className="instruction-footer">
        <Button className="btn btn-next" role="presentation" onClick={onNext}>
          Next
        </Button>
      </div> */}
    </div>
  );
};

InstructionScreen.propTypes = {
  activeInstruction: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    content: PropTypes.string,
    audioUrl: PropTypes.string,
    bgAudioUrl: PropTypes.string,
  }),
  instructionTimeLeft: PropTypes.number,
  studentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onNext: PropTypes.func.isRequired,
};

const mapStateToProps = ({ engine, auth }) => ({
  activeInstruction: engine.activeInstruction,
  instructionTimeLeft: engine.instructionTimeLeft,
  studentId: auth.user?.id,
});

const mapDispatchToProps = dispatch => ({
  onNext: () => dispatch(advanceInstruction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InstructionScreen);
